import { EditableFieldProps } from '../core-field/editable-field-json-props'

export const UI2_TEXT_AREA_FIELD_DEFAULT_PROPS: Partial<UI2TextAreaFieldProps> = {
  /**
   * Mobile uses 3; web uses 4. Schema authors who need a specific count should
   * always set this explicitly — do not rely on either platform's default.
   */
  rows: 3,
  autoGrow: true,
}

export interface UI2TextAreaFieldProps extends EditableFieldProps<string> {
  /** Fixed row count. Ignored when `autoGrow` is true. */
  rows?: number
  /** Grow with content up to `maxRows`. */
  autoGrow?: boolean
  /** Upper bound on rows when `autoGrow` is true. */
  maxRows?: number
  autoFocus?: boolean
  translationTable?: any
}
